import { Component, inject } from '@angular/core';
import { IRequiredReportFields } from '../interfaces/irequired-report-fields';
import { ActivatedRoute } from '@angular/router';
import { ReportService } from '@core/services/report.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { IReportSearch } from '../interfaces/ireport-search';
import { take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'drdp-state-group',
  standalone: false,
  templateUrl: './state-group.component.html',
  styleUrl: './state-group.component.scss',
})
export class StateGroupComponent {
  requiredFields: IRequiredReportFields = {
    state: true,
    agency: false,
    globalRatingPeriod: true,
    ageGroup: true,
    requireMultipleRatingPeriods: false
  };

  reportService = inject(ReportService); 
  dialog = inject(MatDialog);
  route = inject(ActivatedRoute);
  private translocoService = inject(TranslocoService);
  is2025: boolean = false;
  title: string = '';

  ngOnInit(): void {
    this.is2025 = this.route.snapshot.data['is2025'] ?? false;
    this.title = this.translocoService.translate('reports.stateGroup.title', { year: this.is2025 ? '2025' : '2015' });
  }

  showReport(searchValue: IReportSearch): void {
    const service = (payload: IReportSearch) => this.is2025 
      ? this.reportService.saveStateGroupRequest2025(payload)
      : this.reportService.saveStateGroupRequest(payload);
    
    service(searchValue)
      .pipe(take(1))
      .subscribe((res: boolean) => {
        if (res) this.displaySuccessMessage();
      });
  }

  displaySuccessMessage(): void {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('reports.requestSubmitted.title'),
          message: this.translocoService.translate('reports.requestSubmitted.message'),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('reports.requestSubmitted.confirm'),
          showCancel: false,
        },
      },
    };
    this.dialog.open(ConfirmationModalComponent, { data: modal });  
  }
}
